import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { OperationsService } from '../../services/operations.service';
import {Observable} from "rxjs";

declare var closeModal: any;
declare var openModal: any;

@Component({
  selector: 'div [modal-sync-calendar]',
  templateUrl: './modal-sync-calendar.component.html',
  styleUrls: ["./modal-sync-calendar.component.css"],
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})
export class ModalSyncCalendarComponent {

  @Input() calendarLink: Observable<string>;

  @ViewChild("calendarLinkInput") calendarLinkInput: ElementRef<HTMLInputElement>;
  @ViewChild("calendarLinkCopyAlert") calendarLinkCopyAlert: ElementRef<HTMLParagraphElement>

  calendarLinkUrl: string;

  inizializza(){
    if(!this.calendarLinkUrl) {
        this.calendarLink.subscribe(it => {
            this.calendarLinkUrl = it;
        });
    }
    openModal('modalSyncCalendar');
  }

  manageModal() {
    closeModal('modalSyncCalendar');
  }

  copy(){
    this.calendarLinkInput.nativeElement.focus();
    this.calendarLinkInput.nativeElement.select();

    if(navigator.clipboard) {
      navigator.clipboard.writeText(this.calendarLinkUrl)
        .then(() => console.log("Calendar copied to clipboard!"))
        .then(() => {
          this.calendarLinkCopyAlert.nativeElement.style.opacity = "1";
          setTimeout(() => {
            this.calendarLinkCopyAlert.nativeElement.style.opacity = "0";
          }, 5000);
        });
    }
  }

}
